import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Assignments } from '../_models/assignments';
import { Operation } from '../_models/operation';
import { AssignmentsService } from '../_services/assignments.service';
import { MessService } from '../_services/mess-service.service';
import { OperationsService } from '../_services/operations.service';

@Component({
  selector: 'app-employee-responsibilities',
  templateUrl: './employee-responsibilities.component.html',
  styleUrls: ['./employee-responsibilities.component.scss'],
})
export class EmployeeResponsibilitiesComponent implements OnInit, OnDestroy {
  loading: boolean = true;

  updateEmployeeResp: FormGroup;

  allEmployees: Assignments[];

  allOperations: Operation[];

  selectedItemsGroup: number[] = [];

  users: FormArray;

  subscriptions: Subscription[] = [];

  constructor(
    private assignmentsService: AssignmentsService,
    private operationsService: OperationsService,
    private messService: MessService,
    private fb: FormBuilder
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    // * Create form
    this.updateEmployeeResp = this.fb.group({
      users: this.fb.array([]),
    });

    this.users = this.updateEmployeeResp.get('users') as FormArray;

    this.subscriptions.push(
      this.assignmentsService.getAllAssignments().subscribe((users) => {
        this.allEmployees = users;
        this.loadInitialForm();
        this.loading = false;
      })
    );

    this.subscriptions.push(
      this.operationsService.getAllOperations().subscribe((operations) => {
        this.allOperations = operations;
        this.loading = false;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Update employee responsibilities
  onupdateEmployeeResp() {
    const employe = this.updateEmployeeResp.getRawValue();
    this.assignmentsService.updateAssignments(employe).subscribe(
      () => {
        this.messService.add({
          severity: 'success',
          title: 'Uspešno ažuriranje',
          detail: 'Uspešno ste ažurirali zaduženja.',
        });
      },
      (err) => {
        this.messService.addError({
          severity: 'error',
          title: 'Greška',
          detail: 'Došlo je do greške, pokušajte ponovo!',
        });
      }
    );
  }

  // * Helpers === //
  onCheckItem(itemValue, index) {
    let chosenUserGroup = this.getControls[index];
    let chosenUserAssignments = this.getControls[index].value.assignments;

    if (chosenUserAssignments.includes(itemValue)) {
      // If assignment ID (itemValue) is already checked then remove it from assignments array
      chosenUserAssignments = chosenUserAssignments.filter(
        (item) => item !== itemValue
      );
      chosenUserGroup.patchValue({
        assignments: chosenUserAssignments,
      });
    } else {
      chosenUserAssignments.push(itemValue);
    }
  }

  loadInitialForm() {
    this.allEmployees.forEach((employee) => {
      this.users.push(
        this.fb.group({
          id: [employee.id],
          assignments: [employee.assignments],
        })
      );
    });
  }

  get getControls() {
    return (<FormArray>this.updateEmployeeResp.get('users')).controls;
  }
}
